import {
  CurrentEnvironment,
  INTELLIO_TOOLS_API_KEY_ENV_MAP,
  INTELLIO_TOOLS_API_LINKS,
  NOVE8_SUBSCRIPTIONS_API_KEY_ENV_MAP,
  NOVE8_SUBSCRIPTIONS_ENV_MAP,
} from 'root-constants'
import { SubscriptionsApi } from './SubscriptionsApi'
import { LearnWorldsApi } from './LearnWorldsApi'
import { GeoApi } from './GeoApi'
import { ApiService } from 'services/api.service'

const subscriptionsApiService = new ApiService(
  `https://${
    NOVE8_SUBSCRIPTIONS_ENV_MAP[import.meta.env.CURRENT_ENV] ||
    NOVE8_SUBSCRIPTIONS_ENV_MAP[CurrentEnvironment.DEV]
  }`,
  new Headers({
    'x-api-key':
      NOVE8_SUBSCRIPTIONS_API_KEY_ENV_MAP[import.meta.env.CURRENT_ENV] ||
      NOVE8_SUBSCRIPTIONS_API_KEY_ENV_MAP[CurrentEnvironment.DEV],
  }),
)

const learnWorldsApiService = new ApiService(
  INTELLIO_TOOLS_API_LINKS[import.meta.env.CURRENT_ENV] ||
    INTELLIO_TOOLS_API_LINKS[CurrentEnvironment.DEV],
  new Headers({
    'x-api-key':
      INTELLIO_TOOLS_API_KEY_ENV_MAP[import.meta.env.CURRENT_ENV] ||
      INTELLIO_TOOLS_API_KEY_ENV_MAP[CurrentEnvironment.DEV],
  }),
)

const geoApiService = new ApiService('')

export const subscriptionsApi = new SubscriptionsApi(subscriptionsApiService)
export const learnWorldsApi = new LearnWorldsApi(learnWorldsApiService)
export const geoApi = new GeoApi(geoApiService)
